import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './analytics';
import { initTelemetry } from '@/shared/lib/telemetry';
import './index.css';

// Initialize analytics and telemetry (deferred, non-blocking)
initAnalytics();
initTelemetry();

const root = document.getElementById('root');
if (!root) throw new Error('Application root element is missing.');

const application = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (root.hasChildNodes()) {
  ReactDOM.hydrateRoot(root, application);
} else {
  ReactDOM.createRoot(root).render(application);
}
